import { Card } from '@components'
import Fields from '@components/fields'
import {
  StyleFormFieldWrapper,
  StyleFormRowWrapper,
} from '@components/fields/style'
import { cardStyle, StyleCardTitle } from '@components/styles'
import { Form, Formik } from 'formik'
import { Fragment } from 'react'
import { useSelector } from 'react-redux'

const CustomerDetail = () => {
  const { data: user } = useSelector((state: any) => state.singleUser)

  const initialValues = {
    name: user?.name || '',
    email: user?.email || '',
    phoneNo: user?.phoneNo || '',
    address: user?.address || '',
  }
  return (
    <Fragment>
      <Card customStyle={cardStyle}>
        <StyleCardTitle>Personal Information</StyleCardTitle>
        <Formik
          initialValues={initialValues}
          onSubmit={() => {}}
          enableReinitialize
        >
          {({ handleSubmit }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <StyleFormRowWrapper>
                  <StyleFormFieldWrapper>
                    <Fields.Input
                      name="name"
                      disabled
                      label="Full Name"
                      styleWrapper="width:100%"
                    />
                  </StyleFormFieldWrapper>
                  <StyleFormFieldWrapper>
                    <Fields.Input
                      name="email"
                      type="email"
                      disabled
                      label="Email"
                      styleWrapper="width:100%"
                    />
                  </StyleFormFieldWrapper>
                  <StyleFormFieldWrapper>
                    <Fields.PhoneInput
                      name="phoneNo"
                      disabled
                      label="Mobile Number"
                      styleWrapper="width:100%"
                    />
                  </StyleFormFieldWrapper>
                  <StyleFormFieldWrapper>
                    <Fields.Input
                      name="address"
                      disabled
                      label="Address"
                      styleWrapper="width:100%"
                    />
                  </StyleFormFieldWrapper>
                </StyleFormRowWrapper>
              </Form>
            )
          }}
        </Formik>
      </Card>
    </Fragment>
  )
}

export default CustomerDetail
